import { getRoot, getEnv } from '@invisr/mobx-state-tree'
import type { IStore } from '../store/store'

export function getDataSourceDbKeyPrefix(stateTreeNode) {
    const root = getRoot<IStore>(stateTreeNode)
    const env = getEnv(stateTreeNode)
    if (env.isStaticSite) {
      return stateTreeNode.key.replace(stateTreeNode.id, '')
    }
    if (root?.assignmentVersionId) {
        return `build:${root.assignmentVersionId}:dataSources:`
    }

    const appKey = (root?.currentAppKey) || (typeof window !== 'undefined' && (window as any).store && window.store.currentAppKey)
    return appKey && `app:${appKey}:dataSources:`
}
